import { useRoute } from 'vue-router'

export function useMeta() {
  const route = useRoute()

  const updateDocumentTitle = (title = route.meta?.title, isAuthPages = false) => {
    const prefix = 'MobileAction'
    if (isAuthPages) {
      document.title = `${prefix} - ${title} | Boost App and Game Growth`
    }
    else {
      document.title = title ? `${prefix} | ${title}` : prefix
    }
  }

  return {
    updateDocumentTitle,
  }
}
